import { showMessage } from 'app/messages/actions';
import { connect } from 'react-redux';
import { connectLiveLinks } from '../../../live-links/index.js';
import { type ContentPreviewSlice, closePreview, selectPreviewRoute, setIframe, setPreviewRoute } from '../../slice.js';
import ContentPreview, { type ContentPreviewStateProps } from './content-preview.js';

function mapStateToProps(state: ContentPreviewSlice): ContentPreviewStateProps {
  const selection = selectPreviewRoute(state);
  return {
    selection
  };
}

const mapDispatchToProps = {
  closePreview,
  setPreviewRoute,
  setIframe,
  showMessage
};

export default connectLiveLinks(connect(mapStateToProps, mapDispatchToProps)(ContentPreview));
